import React from 'react'
import { GlobalStyle } from '@tumelo/designsystem'
import {
  LoggerService,
  LoggerServiceConsole,
  LoggerServiceSentry,
  LoggerServiceCompound,
  LoggerProvider,
} from '@tumelo/logging'
import { Auth } from '@/application/Auth'
import { getEnvironmentConfig } from '@/application/Environment/getEnvironmentConfig'
import { CookieBanner } from '@/components/CookieBanner'
import * as Analytics from '@/application/Providers/AnalyticsProvider'
import { PageErrorBoundary } from '@/components/pages/PageErrorBoundary'
import { AuthProvider } from './AuthProvider'
import { StyledComponentsThemeProvider } from './ThemeProvider'

export const Providers: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <LoggerProvider logger={setupLoggingService()}>
      <StyledComponentsThemeProvider>
        <GlobalStyle />
        <CookieBanner />
        <Auth>
          <AuthProvider>
            <PageErrorBoundary>
              <Analytics.Provider>
                <Analytics.SetUserProperties>
                  <Analytics.PageViewFromLocationPathname>{children}</Analytics.PageViewFromLocationPathname>
                </Analytics.SetUserProperties>
              </Analytics.Provider>
            </PageErrorBoundary>
          </AuthProvider>
        </Auth>
      </StyledComponentsThemeProvider>
    </LoggerProvider>
  )
}

const setupLoggingService = (): LoggerService => {
  const { environment } = getEnvironmentConfig()

  const dsn = 'https://7d5ae0c85c7bc1e7aa2e2f6afba1df2b@o365838.ingest.us.sentry.io/4507095225466880'
  const release = process.env.NEXT_PUBLIC_APP_RELEASE // in CI will contain the COMMIT_SHA

  // feedback widget disabled in prod before getting some product feedback
  const init = release
    ? { dsn, release, environment, enableFeedbackWidget: true }
    : { dsn, environment, enableFeedbackWidget: true }

  const sentryLogger = new LoggerServiceSentry(init)
  return new LoggerServiceCompound(LoggerServiceConsole, sentryLogger)
}
